import { render, staticRenderFns } from "./RaceListSection.vue?vue&type=template&id=4af52085&scoped=true"
import script from "./RaceListSection.vue?vue&type=script&lang=ts"
export * from "./RaceListSection.vue?vue&type=script&lang=ts"
import style0 from "./RaceListSection.vue?vue&type=style&index=0&id=4af52085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af52085",
  null
  
)

export default component.exports